import { useCallback, useEffect, useRef, useState } from 'react';
import API from 'api/api';
import { translateApiError } from 'i18n/translateApiError';

export function useGetPartnerQuarterScore() {
  const [score, setScore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const fetchScore = useCallback(async (signal) => {
    if (mountedRef.current) {
      setLoading(true);
      setError(null);
    }

    try {
      const response = await API.get('/users/partners/me/score', { signal });
      if (mountedRef.current) {
        setScore(response?.data || null);
      }
    } catch (err) {
      if (err.name === 'CanceledError' || err.code === 'ERR_CANCELED') return;
      if (mountedRef.current) {
        setError(translateApiError(err, 'Failed to fetch partner score'));
      }
    } finally {
      if (mountedRef.current) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchScore(controller.signal);
    return () => controller.abort();
  }, [fetchScore]);

  const refetch = useCallback(() => {
    const controller = new AbortController();
    fetchScore(controller.signal);
    return () => controller.abort();
  }, [fetchScore]);

  return { score, loading, error, refetch };
}
